





















import { Vue, Component, Prop } from 'vue-property-decorator';

import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import DelayedPlanOverview from '@/componentsV2/molecules/DelayedPlanOverview/DelayedPlanOverview.vue';

@Component({
  components: {
    Typography,
    DelayedPlanOverview
  }
})
export default class Overview extends Vue {
  @Prop() subscription!: any;

  get tPrefix() {
    return 'modals.billing.reactivation.overviewMitingDate';
  }
}
